import React, { useState, useRef, useEffect } from 'react';
import StatusBar from '@dataGrid/components/StatusBar';
import DataGrid from '@dataGrid';
import ReceiverGridHeader from './GridHeader';

const constructStatusBar = (receiverList) => {
  return [
    {
      label: `${receiverList.length} Receivers`
    }
  ];
};

const ReceiverDataGrid = ({
  classes,
  gridConfig,
  openAddEditReceiverPanel,
  gridData,
  selectedReceivers,
  showReceiverForm,
  setSelectedReceiverData,
  openDeleteReceiver,
  selectedReceiverData
}) => {
  const [quickFilterText, setQuickFilterText] = useState('');
  const gridApi = useRef(null);

  const updateQuickFilterText = (value) => {
    setQuickFilterText(value);
  };

  const onGridReady = ({ api }) => {
    gridApi.current = api;
  };

  const onRowDataUpdated = () => {
    if (selectedReceivers.length && gridApi?.current) {
      gridApi.current.forEachNode((node) => {
        if (selectedReceivers.includes(node.data.receiverId)) {
          gridApi.current.ensureIndexVisible(node.rowIndex);
          node.setSelected(true);
        } else {
          node.setSelected(false);
        }
      });
    }
  };

  useEffect(() => {
    if (!selectedReceiverData && gridApi.current) {
      gridApi.current.deselectAll();
    }
  }, [selectedReceiverData]);

  const onSelectionChanged = () => {
    if (setSelectedReceiverData && gridApi) {
      const selectedRow = gridApi.current?.getSelectedRows().map((receiver) => receiver.receiverId);
      setSelectedReceiverData(selectedRow);
    }
  };
  return (
    <div className={`${classes.moduleContainer}`}>
      <div className={`${classes.gridContainer} ${classes.receiverGridContainer}`}>
        <ReceiverGridHeader
          updateQuickFilterText={updateQuickFilterText}
          classes={classes}
          openAddEditReceiverPanel={openAddEditReceiverPanel}
          selectedReceivers={selectedReceivers}
          openDeleteReceiver={openDeleteReceiver}
          showReceiverForm={showReceiverForm}
          gridApi={gridApi.current}
        />
        <div className={`${classes.dataGrid} ${classes.receiverGrid}`}>
          <DataGrid
            defaultColDef={gridConfig.config.defaultColDef}
            columnDefs={gridConfig.config.columns}
            config={gridConfig.config}
            enableFilter={gridConfig.config.enableFilter}
            enableSorting={gridConfig.config.enableSorting}
            rowSelection={gridConfig.config.rowSelection}
            rowData={gridData}
            getRowId={(params) => params.data.receiverId}
            onGridReady={onGridReady}
            suppressRowClickSelection={showReceiverForm}
            quickFilterText={quickFilterText}
            onRowDataUpdated={onRowDataUpdated}
            onSelectionChanged={onSelectionChanged}
            panelLabel={(filteredData) => (
              <StatusBar data={constructStatusBar(filteredData)} customClass={classes.statusBar} />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default ReceiverDataGrid;
